// extracted by mini-css-extract-plugin
export default {"container":"QrInformation_container__fRWjg","locationActionWrap":"QrInformation_locationActionWrap__BNEdW"};